const patterns =
[
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         ".",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         ".",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         "."
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ],
   [
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         "."
      ],
      [
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         "."
      ]
   ],
   [
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         ".",
         ".",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         ".",
         " ",
         " ",
         " ",
         ".",
         ".",
         ".",
         "."
      ],
      [
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ],
      [
         " ",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " ",
         ".",
         " ",
         " ",
         " ",
         " "
      ]
   ]
]

export default patterns